const state = {
  driver_id: '',
  action: '',
  last: {}
}

const getters = {
  current: state => ({ driver_id: state.driver_id, action: state.action })
}

const actions = {
  async startTracking(ctx, driver) {
    if (ctx.state.driver_id && ctx.state.driver_id !== driver) {
      await ctx.dispatch('stopTracking', ctx.state.driver_id)
    }
    else if (ctx.state.action === 'start-update') return
    ctx.commit('START', driver)
    const res = await ctx.dispatch('api', {
      entity: 'user',
      action: 'tracking',
      payload: ctx.getters.current
    }, { root: true })
    console.log(res?.data)
  },

  async stopTracking(ctx, driver) {
    if(ctx.state.action !== 'start-update') return
    ctx.commit('STOP', driver)
    const res = await ctx.dispatch('api', {
      entity: 'user',
      action: 'tracking',
      payload: ctx.getters.current
    }, { root: true })
    console.log(res?.data)
  },

  async finishTracking(ctx, driver) {
    if(ctx.state.action !== 'start-update') return
    ctx.commit('FINISH', driver)
    const res = await ctx.dispatch('api', {
      entity: 'user',
      action: 'tracking',
      payload: ctx.getters.current
    }, { root: true })
    console.log(res?.data)
  },
}

const mutations = {
  START: (state, driver) => {
    state.action = 'start-update'
    state.driver_id = driver
  },
  STOP: (state) => {
    state.action = 'stop-update'
    state.last = Object.assign(state.last, state)
  },
  FINISH: (state) => {
    state.action = 'finish-update'
    state.last = Object.assign(state.last, state)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
